export default __webpack_public_path__ + "static/media/6.eaca61b3.png";